const initialState = {
  documentation: null,
  formState: {
    data: {},
  },
  commentFormState: {
    data: {},
  },
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_DOCUMENTATION': {
      return {
        ...state,
        documentation: payload.documentation,
        formState: {
          data: payload.documentation,
        },
      }
    }
    case 'ON_FORM_UPDATE': {
      return {
        ...state,
        formState: payload.formState,
      }
    }
    case 'ON_COMMENT_FORM_UPDATE': {
      return {
        ...state,
        commentFormState: payload.commentFormState,
      }
    }
    case 'ADD_COMMENT': {
      return {
        ...state,
        commentFormState: initialState.commentFormState,
      }
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/Documentation/Documentation.reducer.js